const inventorySummaryDataFormat = {
  equipmentCategory: "",
  totalStock: 0,
  availableStock: 0,
  inQuarantine: 0,
  totalExpiredCertificates: 0,
  atProject: 0,
  latestCreatedAt: "",
  equipmentType: "",
};

export default inventorySummaryDataFormat;
